export default __webpack_public_path__ + "media/images/home/en/preview-6-9830afb261675f71563a86c937fcc711.jpg";